module.exports = __webpack_public_path__ + "static/media/brand.a97edd67.svg";